export default __webpack_public_path__ + "3fffdb84af9f6f9c5fd568b7f724d7c0.png";